// Ref. https://usehooks.com/useWindowSize/
import { useEffect, useState } from "react";

const MIN_DESKTOP_SCREEN_WIDTH = 768;

export interface WindowSize {
  width?: number;
  height?: number;
}
export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({});
  useEffect(() => {
    const handleResize = (): void => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
};

export const useIsDesktopScreenSize = (): boolean => {
  const windowSize = useWindowSize();
  return windowSize.width
    ? windowSize.width >= MIN_DESKTOP_SCREEN_WIDTH
    : false;
};

export const useIsMobileScreenSize = (): boolean => {
  return !useIsDesktopScreenSize();
};
